import type {
  ReferentialModel,
  ReferentialModelsParams,
  UseReferentialModelsOptions,
} from "./referential-models.type";

import { REFERENTIAL_NAMES } from "../referential.enum";
import { useReferential } from "../referential.query";

export const useReferentialModels = (options?: UseReferentialModelsOptions) => {
  const { data, ...result } = useReferential<
    ReferentialModel[],
    ReferentialModelsParams
  >(REFERENTIAL_NAMES.MODELS, options);

  return {
    ...result,
    models: data ?? [],
  };
};

export const useReferentialLoggableModels = (
  options?: UseReferentialModelsOptions
) => {
  return useReferentialModels({
    ...options,
    params: { ...options?.params, "filter[loggable]": true },
  });
};
